import {BasicEntity} from '../../framework/message/BasicEntity';
import {TranslatedEmb} from '../../locale/message/TranslatedEmb';

export class Comment extends BasicEntity {
comment: TranslatedEmb;
owner: string;
sourceComment: Comment;
targetCode: string;
targetKind: string;
}

